export default __webpack_public_path__ + "static/sensory-overload-4d3b041f18774809e7b7acc3f70c6177.jpg";